import React from "react";
import "./LoaderStyle.css";

const Loader = () => {
  return (
    <>
      <div className="loader_container">
        <div className="custom-loader"></div>
      </div>
    </>
  );
};

export default Loader;
